'use client';
import { Dictionary } from '@/src/lib/dictionary/types';
import React from 'react';
import * as LoadingSpinner from '@/src/app/components/LoadingSpinner/LoadingSpinner';

export default function UserProfileButtonLoading({ dict }: { dict: Dictionary }) {
  return (
    <div className="w-fit bg-black text-white flex flex-row items-stretch h-full no-underline! uppercase">
      <span className="w-12 h-12 inline-flex justify-center items-center">
        <LoadingSpinner.default small />
      </span>
      <span className="pr-5 pl-1 inline-flex justify-center items-center" data-testid="button-text">
        {dict.general.loading}
      </span>
    </div>
  );
}
